import { render } from "./BrandTrikoder.vue?vue&type=template&id=95bc882a"
import script from "./BrandTrikoder.vue?vue&type=script&lang=ts"
export * from "./BrandTrikoder.vue?vue&type=script&lang=ts"

import "./BrandTrikoder.vue?vue&type=style&index=0&id=95bc882a&lang=scss"
script.render = render

export default script